import {useCallback, useMemo} from 'react'

import {useBranch, useBuildTypeId} from '../hooks/routes'
import type {
  Branch,
  GetAllBranchesOfBuildTypeApiArg,
  GetAllBranchesOfBuildTypeMergedApiArg,
} from '../services/rest'
import {stringifyId} from '../types'

import {getBuildFields} from './builds'

const getBranchGroupLocator = (branch: Branch): string => {
  if (!branch) {
    return ''
  }

  if (branch.groupFlag === true && branch.internalName != null) {
    return `group:(${branch.internalName})`
  }

  return ''
}
export const useBranchesWithBuildsArg = (): GetAllBranchesOfBuildTypeMergedApiArg => {
  const buildTypeId = useBuildTypeId()!
  const branchFilter = useBranch()
  const getArg = useCallback(
    (buildsLocator: string, branchLocator?: string): GetAllBranchesOfBuildTypeApiArg => ({
      btLocator: `id:${stringifyId(buildTypeId)}`,
      locator: `${branchLocator != null ? `${branchLocator},` : ''}${
        branchFilter != null && branchFilter.groupFlag === true
          ? `${getBranchGroupLocator(branchFilter)},`
          : 'policy:ACTIVE_HISTORY_AND_ACTIVE_VCS_BRANCHES'
      }`,
      fields: `branch(internalName,name,default,active,groupFlag,builds(build(${getBuildFields({
        withQueuedInfo: true,
        withRunningInfo: true,
      })}),href,count,$locator(${buildsLocator},defaultFilter:false)))`,
    }),
    [branchFilter, buildTypeId],
  )
  return useMemo(
    () => ({
      buildTypeId,
      args: [
        getArg('state:(queued:true,running:true),count:100'),
        getArg('state:finished,count:5', 'default:true'),
        getArg('state:finished,count:1', 'default:false'),
      ],
    }),
    [buildTypeId, getArg],
  )
}
